import { authGet, getAuthToken } from './authRequest';
import { parsePermissionNames } from './parsePermissionNames';

export const fetchCurrentUserPermissions = async (authToken = null) => {
  try {
    const token = getAuthToken(authToken);
    if (!token) {
      return [];
    }

    const response = await authGet('/web_users/me/permissions', token);
    return parsePermissionNames(response.data);
  } catch {
    return [];
  }
};
